/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_DescriptionInputs */

const en_no_description = /** @type {(inputs: No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Description`)
};

const fr_no_description = /** @type {(inputs: No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune description`)
};

const de_no_description = /** @type {(inputs: No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Beschreibung`)
};

const it_no_description = /** @type {(inputs: No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna descrizione`)
};

const ru_no_description = /** @type {(inputs: No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет описания`)
};

const es_no_description = /** @type {(inputs: No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin descripción`)
};

const zh_cn2_no_description = /** @type {(inputs: No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无描述`)
};

const ja_no_description = /** @type {(inputs: No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`説明なし`)
};

const hi_no_description = /** @type {(inputs: No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई विवरण नहीं`)
};

const pt_pt2_no_description = /** @type {(inputs: No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem descrição`)
};

/**
* | output |
* | --- |
* | "No Description" |
*
* @param {No_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_description = /** @type {((inputs?: No_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_no_description(inputs)
	if (locale === "de") return de_no_description(inputs)
	if (locale === "it") return it_no_description(inputs)
	if (locale === "ru") return ru_no_description(inputs)
	if (locale === "es") return es_no_description(inputs)
	if (locale === "zh-CN") return zh_cn2_no_description(inputs)
	if (locale === "ja") return ja_no_description(inputs)
	if (locale === "hi") return hi_no_description(inputs)
	if (locale === "pt-PT") return pt_pt2_no_description(inputs)
	return en_no_description(inputs)
});